import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import SockJS from 'sockjs-client/dist/sockjs';
import { Client } from '@stomp/stompjs';

import { useProject } from '../../../context/ProjectContext';
import { enqueueSnackbar } from '../../../redux/notifier/notifierActions';

function ContentUpdateController() {
  const { id: projectId } = useParams();
  const stompClientRef = useRef(null);
  const dispatch = useDispatch();
  const { actions } = useProject();

  const handleShowError = (frame) => {
    dispatch(
      enqueueSnackbar({
        message: 'oopsSomethingWentWrong',
        options: {
          variant: 'warning',
          subMessage: 'pleaseTryAgainLaterContactSupportIfYouNeedHelp',
          subMessageWithContactLink: true,
        },
      }),
    );
  };

  const handleUpdateContent = (updatedContentId) => {
    actions('updateContentById', { contentId: updatedContentId });
  };

  useEffect(() => {
    const socket = new SockJS(`/ws/factive`);

    const stompClient = new Client({
      webSocketFactory: () => socket,

      onConnect: () => {
        stompClient.subscribe(`/activ8/content/description/${projectId}`, (response) => {
          const updatedContentId = response.body;

          handleUpdateContent(updatedContentId);
        });
      },

      onStompError: handleShowError,
    });

    stompClient.activate();
    stompClientRef.current = stompClient;

    return () => {
      stompClient.deactivate();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return null;
}

export default ContentUpdateController;
